import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaUsers, FaBook, FaShoppingCart, FaExchangeAlt, FaArrowRight } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2';

const Dashboard = () => {
    const [jumlahAnggota, setJumlahAnggota] = useState(0);
    const [jumlahBuku, setJumlahBuku] = useState(0); 
    const [jumlahPeminjaman, setJumlahPeminjaman] = useState(0);
    const [jumlahPengembalian, setJumlahPengembalian] = useState(0);

    const [loadingAnggota, setLoadingAnggota] = useState(true);
    const [loadingBuku, setLoadingBuku] = useState(true);
    const [loadingPeminjaman, setLoadingPeminjaman] = useState(true);
    const [loadingPengembalian, setLoadingPengembalian] = useState(true);

    const [errorAnggota, setErrorAnggota] = useState(null);
    const [errorBuku, setErrorBuku] = useState(null); 
    const [errorPeminjaman, setErrorPeminjaman] = useState(null);
    const [errorPengembalian, setErrorPengembalian] = useState(null);

    // Fungsi untuk mengambil data anggota dari backend
    const fetchJumlahAnggota = async () => {
        setLoadingAnggota(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/anggota`);
            setJumlahAnggota(response.data.length);
            setErrorAnggota(null);
        } catch (err) {
            console.error("Error fetching anggota data:", err);
            setErrorAnggota("Gagal memuat jumlah anggota");
            setJumlahAnggota(0);
        } finally {
            setLoadingAnggota(false);
        }
    };

    // Fungsi untuk mengambil data buku dari backend
    const fetchJumlahBuku = async () => {
        setLoadingBuku(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/buku`);
            setJumlahBuku(response.data.length); 
            setErrorBuku(null);
        } catch (err) {
            console.error("Error fetching buku data:", err);
            setErrorBuku("Gagal memuat jumlah buku");
            setJumlahBuku(0);
        } finally {
            setLoadingBuku(false);
        }
    };

    // Fungsi untuk mengambil jumlah peminjaman yang masih 'Dipinjam' atau 'Diajukan Pengembalian'
    const fetchJumlahPeminjaman = async () => {
        setLoadingPeminjaman(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/peminjaman`);
            const peminjamanAktif = response.data.filter(p => p.status_peminjaman !== 'Selesai');
            setJumlahPeminjaman(peminjamanAktif.length);
            setErrorPeminjaman(null);
        } catch (err) {
            console.error("Error fetching peminjaman data:", err);
            setErrorPeminjaman("Gagal memuat jumlah peminjaman");
            setJumlahPeminjaman(0);
        } finally {
            setLoadingPeminjaman(false);
        }
    };

    // Fungsi untuk mengambil jumlah total pengembalian
    const fetchJumlahPengembalian = async () => {
        setLoadingPengembalian(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/peminjaman/pengembalian`);
            setJumlahPengembalian(response.data.length);
            setErrorPengembalian(null);
        } catch (err) {
            console.error("Error fetching pengembalian data:", err);
            setErrorPengembalian("Gagal memuat jumlah pengembalian");
            setJumlahPengembalian(0);
        } finally {
            setLoadingPengembalian(false);
        }
    };

    useEffect(() => {
        fetchJumlahAnggota();
        fetchJumlahBuku();
        fetchJumlahPeminjaman();
        fetchJumlahPengembalian();
    }, []);

    return (
        <Layout title="Dashboard">
            <div className="columns is-multiline is-mobile">
                {/* Card 1: Anggota */}
                <div className="column is-full-mobile is-one-quarter-desktop">
                    <div style={{ background: '#00D1B2', padding: '1rem', borderRadius: '5px', color: 'white' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {loadingAnggota ? (
                                <p className="is-size-2 has-text-weight-bold">...</p>
                            ) : errorAnggota ? (
                                <p className="is-size-4">Error</p>
                            ) : (
                                <p className="is-size-2 has-text-weight-bold">{jumlahAnggota}</p>
                            )}
                            <FaUsers size={50} style={{ opacity: 0.5 }} />
                        </div>
                        <p>Anggota</p>
                        <div style={{ marginTop: '1rem' }}>
                            <Link to="/dataanggota" style={{ color: 'white', fontSize: '0.8rem', textDecoration: 'underline' }}>More info <FaArrowRight /></Link>
                        </div>
                    </div>
                </div>

                {/* Card 2: Buku */}
                <div className="column is-full-mobile is-one-quarter-desktop">
                    <div style={{ background: '#209CEE', padding: '1rem', borderRadius: '5px', color: 'white' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {loadingBuku ? (
                                <p className="is-size-2 has-text-weight-bold">...</p>
                            ) : errorBuku ? (
                                <p className="is-size-4">Error</p>
                            ) : (
                                <p className="is-size-2 has-text-weight-bold">{jumlahBuku}</p> 
                            )}
                            <FaBook size={50} style={{ opacity: 0.5 }} />
                        </div>
                        <p>Buku</p>
                        <div style={{ marginTop: '1rem' }}>
                            <Link to="/databuku" style={{ color: 'white', fontSize: '0.8rem', textDecoration: 'underline' }}>More info <FaArrowRight /></Link>
                        </div>
                    </div>
                </div>

                {/* Card 3: Peminjaman */}
                <div className="column is-full-mobile is-one-quarter-desktop">
                    <div style={{ background: '#FFDD57', padding: '1rem', borderRadius: '5px', color: 'black' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {loadingPeminjaman ? (
                                <p className="is-size-2 has-text-weight-bold">...</p>
                            ) : errorPeminjaman ? (
                                <p className="is-size-4">Error</p>
                            ) : (
                                <p className="is-size-2 has-text-weight-bold">{jumlahPeminjaman}</p>
                            )}
                            <FaShoppingCart size={50} style={{ opacity: 0.5 }} />
                        </div>
                        <p>Peminjaman</p>
                        <div style={{ marginTop: '1rem' }}>
                            <Link to="/datapeminjaman" style={{ color: 'black', fontSize: '0.8rem', textDecoration: 'underline' }}>More info <FaArrowRight /></Link>
                        </div>
                    </div>
                </div>

                {/* Card 4: Pengembalian */}
                <div className="column is-full-mobile is-one-quarter-desktop">
                    <div style={{ background: '#F03A5F', padding: '1rem', borderRadius: '5px', color: 'white' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {loadingPengembalian ? (
                                <p className="is-size-2 has-text-weight-bold">...</p>
                            ) : errorPengembalian ? (
                                <p className="is-size-4">Error</p>
                            ) : (
                                <p className="is-size-2 has-text-weight-bold">{jumlahPengembalian}</p>
                            )}
                            <FaExchangeAlt size={50} style={{ opacity: 0.5 }} />
                        </div>
                        <p>Pengembalian</p>
                        <div style={{ marginTop: '1rem' }}>
                            <Link to="/datakembali" style={{ color: 'white', fontSize: '0.8rem', textDecoration: 'underline' }}>More info <FaArrowRight /></Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content Banner */}
            <div style={{ textAlign: 'center', marginTop: '5rem' }}>
                <FaBook size={100} style={{ color: '#aaa', marginBottom: '1rem' }} />
                <h2 className="title is-3">Perpustakaan SMPN 4 Tilatang Kamang</h2>
                <p>Alamat : Jl. Bukik Kutirik, Koto Tangah, Kec. Tilatang Kamang, Kabupaten Agam, Sumatera Barat | Email : perpus@gmail.com | Nomor Telpon : 07527446088</p>
            </div>
        </Layout>
    );
};

export default Dashboard;